import ObjectCache from './CacheService';
import LogicBaseUserApi from '../server/LogicBaseUserApi';
import UserAccount from '../UserAccount';
import LogicBaseUser from '../../models/logicbaseuser';

class LogicBaseUserCache extends ObjectCache {
  api = LogicBaseUserApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseUser(results._id, results.d, results.fr, results.fe, results.v, results.ss, results.c, results.p, results.pc, results.lc, results.lst);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseUserCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
